<template>
	<div class="project-detail">
    <el-button type="text" icon="el-icon-arrow-left" @click="handleBack()">Return</el-button>
    <el-card style="margin-bottom: 15px">
      <div slot="header" class="keyInfotit">
        <span>{{ keyInfo.projectName }}</span>
      </div>
      <el-row :span="24" class="keyinfobox">
        <el-col :span="10">
          <p>Project Progress</p>
          <el-progress
            :stroke-width="20"
            :show-text="false"
            :percentage="keyInfo.progressRatio"
            stroke-linecap="square"
          >
          </el-progress>
          <p>{{ keyInfo.progressRatio }} %</p>
        </el-col>
        <el-col :span="10" :offset="1">
          <p>Project Manager: {{ keyInfo.projectManager }}</p>
          <p>Proejct Status: {{ detailStatus }}</p>
          <p v-if="detailStatus !== 'Closed'">Time until project deadline(day): {{ keyInfo.maturityDays }}</p>
          <p>Estimated Delivery Date: {{ keyInfo.projectPlanStartDate + '~' + keyInfo.projectPlanEndDate }}</p>
        </el-col>
      </el-row>
    </el-card>
    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="Project Detail Info" name="1">
        <project-application :id="id" :companyOrRepresentative="companyOrRepresentative" @setInfo="getAllData" page="projectDetail" />
      </el-tab-pane>
      <el-tab-pane label="Project Planning" name="2">
        <el-tabs v-model="planningTab">
          <el-tab-pane  name="21" v-if="companyOrRepresentative === '2'">
             <span slot="label">Overall Project Progress<span class="star">*</span></span>
            <project-progress :id="id" :allData="allData" />
          </el-tab-pane>
          <el-tab-pane name="22">
            <span slot="label">Project Milestone Planning<span class="star" v-if="companyOrRepresentative === '1'">*</span></span>
            <milestone-maintenance :id="id" :allData="allData" ref="milestoneMaintenance" />
          </el-tab-pane>
          <el-tab-pane name="23">
            <span slot="label">HLD/LLD Management<span class="star" v-if="companyOrRepresentative === '1'">*</span></span>
            <hldlld :id="id" :allData="allData" />
          </el-tab-pane> 
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="Project Start" name="3">
        <three-meeting :id="id" :allData="allData" :showLastList="false" :companyOrRepresentative="companyOrRepresentative" />
      </el-tab-pane>
      <el-tab-pane label="Project Mgmt. Labor-hour" name="9">
        <div style="padding: 60px 20px; font-size: 16px; font-weight: bold; color: #777;">
          <p>Project Management Labor-hour Submit Link：<a href="javascript:void(0)" @click="goToLabourEnter">Link</a></p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Project Implementation" name="4">
        <el-tabs v-model="prjectImplementationTab" @tab-click="handleClickImplementation">
          <el-tab-pane label="Risk Management" name="41">
            <risk-management :id="id" :allData="allData" />
          </el-tab-pane>
          <el-tab-pane name="42">
            <span slot="label">Weekly Report（Internal）<span class="star" v-if="companyOrRepresentative === '1'">*</span></span>
            <weekly-report :id="id" :allData="allData" ref="weeklyReport" open="detail" />
          </el-tab-pane>
          <el-tab-pane name="43">
            <span slot="label">Weekly Report（Customer）</span>
            <weekly-report-cus :id="id" :allData="allData" ref="weeklyReportCus" open="detail" />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <!-- <el-tab-pane label="Project Engineering Transfer Maintenance" name="5">
        <three-meeting :id="id" :allData="allData" :showLastList="true" />
      </el-tab-pane> -->
      <el-tab-pane label="Project Closure" name="6">
        <project-close :id="id" :keyInfo="keyInfo" :projectManagerAllList="projectManagerAllList" :allData="allData" ref="projectClose" page="projectDetail"  @setCloseType="setCloseType"/>
      </el-tab-pane>
      <el-tab-pane label="Satisfaction Survey" name="8" v-if="closeType === 1">
        <satisfaction-survey :id="id" :isClosed="allData && allData.projectStatus === 5" :companyOrRepresentative="companyOrRepresentative" ref="satisfactionSurvey" />
      </el-tab-pane>
      <el-tab-pane label="Project Maintenance" name="7" v-if="allData && allData.projectStatus !== 5">
        <project-maintenance :id="id" :projectManagerAllList="projectManagerAllList" :allData="allData" ref="projectMaintenance" />
      </el-tab-pane>
      <!-- <el-tab-pane label="Weekly Report Management" name="8" v-if="companyOrRepresentative === '1'">
        <weekly-report :id="id" :allData="allData" ref="weeklyReport" open="detail" />
      </el-tab-pane> -->
    </el-tabs>
	</div>
</template>
<script>
  import moment from 'moment';
  import projectApplication from '../projectApplication';
  import projectMaintenance from '../projectMaintenance';
  import riskManagement from '../riskManagement';
  import milestoneMaintenance from '../milestoneMaintenance';
  import threeMeeting from '../threeMeeting';
  import weeklyReport from '../weeklyReport';
  import weeklyReportCus from '../weeklyReportCus';
  import recipientManagement from '../recipientManagement';
  import hldlld from '../hldlld';
  import projectClose from '../projectClose';
  import projectProgress from '../projectProgress';
  import satisfactionSurvey from '../satisfactionSurvey';
  export default {
    name: 'projectDetail',
    components: {
      projectApplication,
      projectMaintenance,
      riskManagement,
      milestoneMaintenance,
      threeMeeting,
      weeklyReport,
      weeklyReportCus,
      recipientManagement,
      hldlld,
      projectClose,
      projectProgress,
      satisfactionSurvey,
    },
		props: {
			id: {
        type: Number,
        // default: null,
        default: 21,
      },
      detailStatus: {
        type: String,
        default: '',
      },
			page: {
        type: String,
        default: '',
      },
      companyOrRepresentative: {
        type: String,
        default: '',
      },
		},
    created () {
      this.getManagementList();
      this.getKeyProjectInfo();
      if(this.companyOrRepresentative === '2') {
        this.planningTab = '21';
      } else {
        this.planningTab = '22';
      }
    },
    data () {
      return {
        activeTab: '1',
        projectInfo: {},
        allData: {},
        projectManagerAllList: [],
        prjectPlanningActive: ['1', '2'],
        prjectImplementationTab: '41',
        planningTab: '22',
        keyInfo: {},
        closeType: '',
      }
    },
    methods: {
      goToLabourEnter() {
        this.$router.push({ path: '/labourEnter/enter' });
        this.$store.commit('tagChange', 'labourEnter');
      },
      getAllData(data) {
        this.allData = data;
        this.$refs.projectMaintenance.delayForm = {
					startTime: data.projectPlanStartDate ? moment(data.projectPlanStartDate).format('YYYY-MM-DD HH:mm:ss') : '',
					endTime: data.projectPlanEndDate ? moment(data.projectPlanEndDate).format('YYYY-MM-DD HH:mm:ss') : '',
				};
        // this.$refs.weeklyReport.setData(data);
        this.$refs.projectClose.setData({...data,page:'detail'});
      },
			handleBack() {
				this.activeTab = '1';
				this.$emit('closeDetail');
			},
      handleClick(tab) {
        // if(tab.name === '8') {
        //   this.$refs.weeklyReport.getWeeklyInfo();
        // }
        if(tab.name === '2') {
          this.$refs.milestoneMaintenance.getMilestone();
        }
      },
      handleClickImplementation(tab) {
        if(tab.name === '42') {
          this.$refs.weeklyReport.getWeeklyInfo();
        } else if(tab.name === '43') {
          this.$refs.weeklyReportCus.getWeeklyInfo();
        }
      },
      getManagementList() {
        let url2 =`${this.$store.state.islhurl}majorProjectManager/fuzzyQueryByName?empName=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url2, params).then(
					res => {  
						if(res) {
							this.projectManagerAllList = res
						}
					}
				)
      },
      getKeyProjectInfo() {
        let url =`${this.$store.state.islhurl}majorProject/getKeyProjectInfoById?id=${this.id}`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {  
						if(res.code === 200) {
							this.keyInfo = res.data
						}
					}
				)
      },
      setCloseType(type) {
        console.log('type', type)
        this.closeType = type
      },
		},
  }
</script>
<style lang="less" scoped>
.project-detail {
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
	}
  /deep/.el-card__header {
    padding: 14px 20px;
  }
  .keyInfotit span {
    color: #409EFF;
  }
  .keyinfobox {
    p {
      line-height: 25px;
      font-size: 14px;
      padding: 5px;
    }
  }
  .star {
    color: #F56C6C;
    padding-left: 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectDetail/index.vue